import { render, staticRenderFns } from "./RuleCustomValueEditor.vue?vue&type=template&id=238c6f70"
import script from "./RuleCustomValueEditor.vue?vue&type=script&lang=ts"
export * from "./RuleCustomValueEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports